import React from 'react';
import { Star, Calendar, FileText, Heart, User, Sun, BookOpen, HelpCircle } from 'lucide-react';
export const servicePages = ['service-natal', 'service-solar', 'service-compatibility', 'service-combo', 'service-forecast', 'service-consultation'];
export const knowledgePages = ['astro-daily', 'interpretations', 'blog', 'faq'];
export const serviceItems = [{
  page: 'service-natal',
  icon: <Star className="w-4 h-4 text-indigo-500" data-id="element-17414" />,
  labelKey: 'services.natal',
  descKey: 'services.natal.desc'
}, {
  page: 'service-solar',
  icon: <Calendar className="w-4 h-4 text-amber-500" data-id="element-17415" />,
  labelKey: 'services.solar',
  descKey: 'services.solar.desc'
}, {
  page: 'service-combo',
  icon: <FileText className="w-4 h-4 text-slate-500" data-id="element-17416" />,
  labelKey: 'services.combo',
  descKey: 'services.combo.desc'
}, {
  page: 'service-compatibility',
  icon: <Heart className="w-4 h-4 text-rose-500" data-id="element-17417" />,
  labelKey: 'services.compatibility',
  descKey: 'services.compatibility.desc'
}, {
  page: 'service-forecast',
  icon: <Calendar className="w-4 h-4 text-emerald-500" data-id="element-17418" />,
  labelKey: 'services.forecast',
  descKey: 'services.forecast.desc'
}, {
  page: 'service-consultation',
  icon: <User className="w-4 h-4 text-violet-500" data-id="element-17419" />,
  labelKey: 'services.consultation',
  descKey: 'services.consultation.desc'
}];
export const knowledgeItems = [{
  page: 'astro-daily',
  icon: <Sun className="w-4 h-4 text-amber-500" data-id="element-17420" />,
  labelKey: 'Астро-календарь',
  descKey: 'Гороскоп, луна и календарь'
}, {
  page: 'interpretations',
  icon: <BookOpen className="w-4 h-4 text-indigo-500" data-id="element-17421" />,
  labelKey: 'knowledge.interpretations',
  descKey: 'Трактовки планет, домов и аспектов'
}, {
  page: 'blog',
  icon: <FileText className="w-4 h-4 text-emerald-500" data-id="element-17422" />,
  labelKey: 'knowledge.blog',
  descKey: 'Статьи и прогнозы от экспертов'
}, {
  page: 'faq',
  icon: <HelpCircle className="w-4 h-4 text-amber-500" data-id="element-17423" />,
  labelKey: 'Вопросы и ответы',
  descKey: 'Помощь по платформе'
}];